import { Button, Icon, Pill, Select } from 'admination-react'
import { ALLE_KOHORTEN, kohorteLabel, type Kohorte } from '@/core/lib/kohorte'

export function KohortenSelect({
  kohorten,
  value,
  onChange,
  laedt = false,
}: {
  kohorten: readonly Kohorte[]

  value: string | null
  onChange: (beginn: string | null) => void
  /** Holds the pill's place while the first list is still loading. */
  laedt?: boolean
}) {
  const leer = kohorten.length === 0
  if (leer && !laedt) return null
  const options = [
    {
      value: ALLE_KOHORTEN,
      label: 'Alle Kohorten',
      count: kohorten.reduce((sum, k) => sum + k.anzahl, 0),
      testId: 'kohorten-option-alle',
    },
    ...kohorten.map((k) => ({
      value: k.beginn,
      label: kohorteLabel(k.beginn),
      count: k.anzahl,
      testId: `kohorten-option-${k.beginn}`,
    })),
  ]
  return (
    <Pill>
      <Select
        compact
        disabled={leer}
        icon="i-people"
        aria-label="Kohorte"
        title="Kohorte"
        data-testid="kohorten-select"
        options={options}
        value={value ?? ALLE_KOHORTEN}
        onChange={(next) => onChange(next === ALLE_KOHORTEN ? null : next)}
      />
      {value !== null && (
        <Button
          iconOnly
          aria-label="Kohortenfilter zurücksetzen"
          title="Kohortenfilter zurücksetzen"
          data-testid="kohorten-reset"
          onClick={() => onChange(null)}
        >
          <Icon name="i-close" />
        </Button>
      )}
    </Pill>
  )
}
